import { Component, Input, OnInit } from '@angular/core';

import { Observable, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';

import { AppearCondition, AutocompleteCustomOption } from '../../../Forms/components/Autocomplete/autocomplete-custom-option.model';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { SourceGroup } from '../../../Sources/models/source-group.model';
import { Source } from '../../../Sources/models/source.model';
import { SourceGroupService } from '../../../Sources/services/source-group.service';

@Component({
    selector: 'agpr-add-sources-to-group-dialog',
    templateUrl: './add-sources-to-group-dialog.component.html',
    styleUrls: ['./add-sources-to-group-dialog.component.scss'],
    standalone: false
})
export class AddSourcesToGroupDialogComponent extends AbstractDialogComponent implements OnInit {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() sourceList: Source[] = [];
    @Input() id: string;
    subscriptions: Subscription[] = [];
    sourceGroupList$: Observable<SourceGroup[]>;
    selectedSourceGroup: SourceGroup;
    sourceGroupAutocompleteOptions: AutocompleteCustomOption[] = [
        {
            label: 'SourceGroups.selection.autocomplete',
            action: (searchString: string) => {
                const sourceModel = new SourceGroup();
                sourceModel.name = searchString;
                this.sourceGroupService.create(sourceModel).pipe(
                    switchMap((id) => this.sourceGroupService.getById(id))
                ).subscribe(selectedSourceGroup => {
                    this.selectedSourceGroup = selectedSourceGroup;
                });
            },
            appearCondition: AppearCondition.noExactMatchInSuggestions,
            clearOnSelect: true
        }
    ];

    constructor(
        public coreDialogService: CoreDialogService,
        private sourceGroupService: SourceGroupService
    ) {
        super(coreDialogService, 'AddSourcesToGroup');
    }

    ngOnInit() {
        this.sourceGroupList$ = this.sourceGroupService.all$;
    }

    cancel() {
        this.closeDialog();
    }

    addSources() {
        this.sourceList.forEach(source => {
            if (!this.selectedSourceGroup.sourceIds.includes(source.id)) {
                this.selectedSourceGroup.sourceIds.push(source.id);
            }
        });

        this.sourceGroupService.update(this.selectedSourceGroup).subscribe(() => this.cancel());
    }

}
